<div class="d-flex gap-10 flex-wrap-wrap">
  <ng-container *ngIf="!pills?.length">
    <ngx-shimmer-loading
      *ngFor="let shimmer of [1, 2, 3, 4, 5, 6]"
      [width]="'90px'"
      [height]="'28px'"
    ></ngx-shimmer-loading>
  </ng-container>
  <app-button
    [variant]="pill.selected ? 'ghost-secondary' : 'gray'"
    size="small"
    *ngFor="let pill of pills; let i = index"
    (click)="setPills(i)"
  >
    {{ pill.name }}
  </app-button>
</div>
